import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'antd-mobile/dist/antd-mobile.css';
import LoginMobileModal from './LoginMobileModal';
import { dispatch } from '../../App';


class MobileTemplateView extends React.Component {


    constructor() {
        super();
    }

    componentDidMount() {
        if (!localStorage.getItem('token')) {
            dispatch.common.isLogin(false);
        } else {
            dispatch.common.isLogin(true);
        }
    }

    render() {
        return (
            <div>
                {this.props.children}
                {!this.props.isLogin &&
                    <LoginMobileModal isLogin={this.props.isLogin} />}
            </div>
        );
    }

}

export const mobile = {
    state: {
        isLogin: true
    }
}

const mapState = state => {
    return {
        isLogin: state.common.isLogin
    }
};

const MobileTemplate = connect(mapState, null)(MobileTemplateView);
export default withRouter(MobileTemplate);


// WEBPACK FOOTER //
// ./src/page/mobile/MobileTemplate.jsx